import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import CaremapprModal from '../../../components/Modal/CaremapprModal/CaremapprModal';
import CareMapprButton from '../../../components/Button/CareMapprButton';

export interface DuplicationOptions {
  copyChangeType: boolean;
  copyLetters: boolean;
  copyAppointments: boolean;
}

interface DuplicateMedProfileModalProps {
  show: boolean;
  onConfirm: (options: DuplicationOptions) => void;
  onCancel: () => void;
}

const DuplicateMedProfileModal: React.FC<DuplicateMedProfileModalProps> = ({
  show,
  onConfirm,
  onCancel,
}) => {
  const [options, setOptions] = useState<DuplicationOptions>({
    copyChangeType: true,
    copyLetters: true,
    copyAppointments: true,
  });

  // Reset options to default whenever the modal opens
  useEffect(() => {
    if (show) {
      setOptions({
        copyChangeType: true,
        copyLetters: true,
        copyAppointments: true,
      });
    }
  }, [show]);

  const handleCheckboxChange = (field: keyof DuplicationOptions) => {
    setOptions((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleConfirm = () => {
    onConfirm(options);
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <CaremapprModal
      id="duplicate-med-profile-modal"
      show={show}
      onHide={handleCancel}
      size="sm"
      centered
      showCloseButton={false}
      header={
        <div style={{ fontSize: '18px', fontWeight: 600 }}>
          Duplicate Medicine Profile
        </div>
      }
      body={
        <div>
          <p style={{ marginBottom: '20px', fontSize: '14px' }}>
            Select the information you want to copy to the new profile:
          </p>
          <Form>
            <Form.Check
              type="checkbox"
              id="copy-change-type"
              label="Copy change type"
              checked={options.copyChangeType}
              onChange={() => handleCheckboxChange('copyChangeType')}
              style={{ marginBottom: '12px' }}
            />
            <Form.Check
              type="checkbox"
              id="copy-letters"
              label="Copy GP/Pharmacist letter"
              checked={options.copyLetters}
              onChange={() => handleCheckboxChange('copyLetters')}
              style={{ marginBottom: '12px' }}
            />
            <Form.Check
              type="checkbox"
              id="copy-appointments"
              label="Copy appointment details"
              checked={options.copyAppointments}
              onChange={() => handleCheckboxChange('copyAppointments')}
              style={{ marginBottom: '20px' }}
            />
          </Form>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '10px',
              marginTop: '20px',
            }}
          >
            <CareMapprButton
              variant="secondary"
              onClick={handleCancel}
              style={{ minWidth: '80px' }}
            >
              Cancel
            </CareMapprButton>
            <CareMapprButton
              variant="primary"
              onClick={handleConfirm}
              style={{ minWidth: '80px' }}
            >
              Duplicate
            </CareMapprButton>
          </div>
        </div>
      }
    />
  );
};

export default DuplicateMedProfileModal;
